import { PaginationModel, ParamsMapper } from './type'

export const defaultPaginatedResource = { page: 0, per_page: 0, results: [] }
export const defaultTranslatable = { en: '', fr: '' }
export const defaultTranslatableWithImage = {
  ...defaultTranslatable,
  front_image: '',
}
export const defaultRelationShipTranslatable = {
  id: '',
  name: { en: '', fr: '' },
}
export const defaultRelationShipTranslatableWithImage = {
  ...defaultRelationShipTranslatable,
  front_image: '',
}
export class BaseMapper {
  apiMapper?: (value: any) => unknown
  algoliaMapper?: (value: any) => unknown
  elasticsearchMapper?: (value: any) => unknown

  protected defaultValue: unknown

  getMappedObject(params: ParamsMapper): any {
    const { from, data } = params
    let mapper = undefined
    switch (from) {
      case 'api':
        if (this.apiMapper) {
          mapper = this.apiMapper
        } else {
          throw new Error('No function mapper for api')
        }
        break
      case 'algolia':
        if (this.algoliaMapper) {
          mapper = this.algoliaMapper
        } else {
          throw new Error('No function mapper for algolia')
        }
        break
      case 'elasticsearch':
        if (this.elasticsearchMapper) {
          mapper = this.elasticsearchMapper
        } else {
          throw new Error('No function mapper for elasticsearch')
        }
        break
    }
    if (mapper && data) {
      return Array.isArray(data) ? data.map(mapper) : mapper(data)
    } else {
      return Array.isArray(data) ? [] : this.defaultValue
    }
  }
}

export class BasePaginateMapper {
  static defaultValue: PaginationModel<any> = {
    count: 0,
    page_count: 0,
    results: [],
  }
}
